<div class="p-3 flex items-center">
    <span class="text-md font-bold">Tags</span>
    <div class="ml-auto items-center ">
        @if(!tagsInSync){<i class="pi pi-exclamation-circle mr-2"
            [pTooltip]="'The document has been updated; some tags may need to be revalidated to stay in sync.'"
            tooltipPosition="left"></i>}
        @if(role === CONTRACT_USER_ROLE.OWNER || role === CONTRACT_USER_ROLE.EDITOR){
        <!-- Stop button — visible only after initial load confirms extraction is running -->
        @if(!documentInSync && !loading){
        <app-button (clicked)="stopExtracting()" [loading]="stoppingExtraction" [disabled]="stoppingExtraction"
            icon="pi pi-stop-circle" loadingIcon="pi pi-spin pi-spinner" toolTip="Stop tag extraction"
            variant="outlined" severity="danger" class="mr-2" />
        }
        <app-button (clicked)="getTagMappings(true)" loadingIcon="pi pi-refresh" icon="pi pi-refresh"
            toolTip="Extract Tags" variant="outlined" severity="contrast"
            [disabled]="!documentInSync || exhaustionState === 'depleted'" />
        }
    </div>
</div>

<app-credits-overview variant="exhaustioncard" feature="TAG_EXTRACTION" mode="ask" [featureId]="contractId" [userRole]="role"
    [bottomImagePath]="'images/insights-image.png'" (resume)="getTagMappings(true)"
    (exhaustionState)="exhaustionState = $event" />

@if (loading) {
<div class="grid grid-cols-2 gap-4">
    <div *ngFor="let _ of [1, 2, 3, 4, 5]" class="mb-1 col-span-2 animate-pulse">
        <div class="flex flex-row justify-between items-center">
            <div class="flex flex-col gap-2">
                <div class="block h-4 w-32 bg-gray-300 rounded"></div>
                <div class="flex flex-row gap-2 items-center">
                    <div class="relative inline-flex items-center">
                        <div class="h-6 w-24 bg-gray-300 rounded"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex flex-row w-full justify-between items-center mt-2">
            <div class="h-10 bg-gray-300 w-3/4 rounded-base"></div>
            <div class="h-10 w-16 bg-gray-300 rounded-base"></div>
        </div>
    </div>
</div>
}@else {
<!-- Extraction-in-progress banner — shown after initial load confirms agent is running -->
@if(!documentInSync && !loading){
<div class="flex items-center gap-2 px-3 py-2 mb-2 rounded-base bg-gray-50 border border-gray-200">
    <p-progressSpinner [style]="{width: '16px', height: '16px'}" strokeWidth="4"></p-progressSpinner>
    <span class="text-sm text-gray-500 animate-pulse">Tags are being extracted…</span>
</div>
}
<form class="p-3">
    <div class="grid grid-cols-2 gap-4">
        @for(mapping of contractTagMappings; track mapping.tagTypeId;let i = $index) {
        <div class="mb-1 col-span-2">
            <div class="flex flex-row gap-x-4 items-center">
                <div class="flex flex-col flex-1 gap-2 max-h-56 overflow-x-scroll">
                    <label for="location" class="block text-sm font-bold text-gray-700 mr-2 whitespace-nowrap"
                        [ngClass]="{'text-gray-400 opacity-50': !mapping.mappingsInSync}">{{mapping.tagTypeName}}
                    </label>
                    <div class="flex"
                        [ngClass]="{'flex-row gap-x-2 overflow-x-scroll py-2': !onEditTag[i], 'flex-col overflow-y-scroll gap-y-2': onEditTag[i]}">
                        @for(tag of mapping.tags; track tag.tagId){

                        @if(tag.aiGenerated || tag.dataType != 'Custom'){
                        <div class="flex flex-row gap-2 items-center">
                            <div class="relative inline-flex items-center text-nowrap">
                                <app-data-type [dataType]="tag.dataType" [(value)]="tag.tagName" [onEdit]="onEditTag[i]"
                                    (onDelete)="deleteClicked(mapping.tagTypeId,tag.tagId)"
                                    (onValueChange)="changedValue=$event; onEditTag[i]=true"></app-data-type>
                                @if(tag.aiGenerated){
                                <img src="icons/star.svg" pTooltip="AI Generated" tooltipPosition="top"
                                    class="absolute -top-1 -right-1 h-4 w-4 border border-arena-orange-300 rounded-full bg-white p-0.5 shadow"
                                    alt="Star icon">
                                }
                            </div>
                            @if(onEditTag[i]){
                            <div class="relative inline-flex items-center">
                                @if(role === CONTRACT_USER_ROLE.OWNER || role === CONTRACT_USER_ROLE.EDITOR){
                                <span (click)="suggestEdit(mapping.tagTypeId,tag.tagId,false)"
                                    class="status-button check-button mx-1  group cursor-pointer transition-all duration-300 ease-in-out active:scale-95  active:transform">
                                    <i class="pi pi-check small-icon"></i>
                                </span>
                                <span
                                    class="status-button cancel-button mx-1 group cursor-pointer transition-all duration-300 ease-in-out active:scale-95 active:transform"
                                    (click)="suggestEdit(mapping.tagTypeId,tag.tagId ,true)">
                                    <i class="pi pi-times small-icon"></i>
                                </span>
                                }
                            </div>
                            }
                        </div>

                        }
                        @else {
                        <p-chip [label]="tag.tagName | truncate:40"
                            class="bg-arena-orange-300 text-xs chip-truncate text-nowrap"
                            [removable]="mapping.tagTypeId == editTagTypeId"
                            (onRemove)="deleteClicked(mapping.tagTypeId, tag.tagId)" [pTooltip]="tag.tagName"
                            tooltipPosition="top">
                        </p-chip>

                        }

                        }
                    </div>

                    @if(!mapping.tags || mapping.tags.length == 0){
                    <span class="text-sm text-gray-400">No tags added</span>
                    }
                </div>

                @if((!documentInSync && mapping.tags?.length == 0)||mapping.loading){
                <p-progressSpinner class="my-4" [style]="{width: '20px', height: '20px'}"></p-progressSpinner>
                }
                @else{
                <div class="flex items-center">
                    @if(role === CONTRACT_USER_ROLE.OWNER || role === CONTRACT_USER_ROLE.EDITOR){
                    <i class="pi pi-refresh medium-icon mr-4"
                        [ngClass]="exhaustionState === 'depleted' ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'"
                        (click)="exhaustionState !== 'depleted' && getTagMappings(false, mapping.tagTypeId)"></i>
                    }
                    @if(role === CONTRACT_USER_ROLE.OWNER || role === CONTRACT_USER_ROLE.EDITOR){
                    <i class="pi pi-pencil cursor-pointer small-icon" (click)="editClicked(mapping.tagTypeId)"></i>
                    }
                </div>
                }
            </div>
            @if(mapping.tagTypeId == editTagTypeId) {

            <div class="flex flex-row w-full justify-between items-center mt-2">
                <app-autocomplete #autoComplete [suggestions]="tagSuggestions" [config]="{
                        placeholder: 'Type here',
                        emptyMessage: suggestionsLoading ? 'Loading Tags..' : 'No Tags Found',
                        completeOnFocus: true,
                        inputStyleClass: 'border-0 outline-none',
                        panelStyleClass: 'border rounded-base'
                    }" [optionLabel]="'name'" (onComplete)="searchTags($event, mapping.tagTypeId)"
                    (onSelect)="onOptionSelect($event)" (onKeyUp)="selectedTagId=''" class="w-full border rounded-base">
                </app-autocomplete>
                <app-button label="Add" icon="pi pi-plus" variant="outlined" severity="contrast"
                    [disabled]="!selectedTagId" (clicked)="addTagMapping(mapping.tagTypeId)" />
            </div>
            }
        </div>
        }
    </div>
</form>
}